import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "EditFilter"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 4.5H3V6.8775L8.5575 12.4425L9 12.8775V19.5H12V18H13.5V19.5C13.5 20.3284 12.8284 21 12 21H9C8.17157 21 7.5 20.3284 7.5 19.5V13.5L1.9425 7.9425C1.65897 7.66065 1.49968 7.27728 1.5 6.8775V4.5C1.5 3.67157 2.17157 3 3 3H19.5V4.5ZM22.2825 8.46751L20.0325 6.21752C19.8917 6.07553 19.7 5.99567 19.5 5.99567C19.3 5.99567 19.1083 6.07553 18.9675 6.21752L12 13.1925V16.5H15.3075L22.2825 9.53252C22.4245 9.39169 22.5043 9.19999 22.5043 9.00002C22.5043 8.80004 22.4245 8.60834 22.2825 8.46751ZM14.6925 15H13.5V13.8075L17.25 10.0575L18.4425 11.25L14.6925 15ZM18.3075 9.00002L19.5 10.1925L20.6925 9.00002L19.5 7.80752L18.3075 9.00002Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/EditFilter.vue"]]);
